export const UPLOAD_ERRORS = {
  GENERIC: 'JOBS_POSTING_XING_APPLY_UPLOAD_GENERIC_ERROR',
  MAX_FILES_ALLOWED: 'JOBS_POSTING_XING_APPLY_UPLOAD_MAX_X_FILES_ALLOWED_ERROR',
  SINGLE_FILE_ALLOWED: 'JOBS_POSTING_XING_APPLY_UPLOAD_SINGLE_FILE_ALLOWED_ERROR',
  MIME_TYPE_NOT_SUPPORTED: 'JOBS_POSTING_XING_APPLY_UPLOAD_MIME_TYPE_NOT_SUPPORTED_ERROR',
  FILE_SIZE_TOO_LARGE: 'JOBS_POSTING_XING_APPLY_UPLOAD_FILE_SIZE_TOO_LARGE_ERROR',
  UPLOAD_IN_PROGRESS: 'JOBS_POSTING_XING_APPLY_UPLOAD_IN_PROGRESS_ERROR',
  DELETE: 'JOBS_POSTING_XING_APPLY_DELETE_UPLOAD_ERROR',
};

export const DEFAULT_MAX_FILESIZE_BYTES = 5242880; // 5MB
export const DEFAULT_ACCEPTED_MIME_TYPES =
  'text/plain,application/msword,application/pdf,image/jpeg,image/png,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.oasis.opendocument.text,application/rtf,text/rtf';

export type UploadError = keyof typeof UPLOAD_ERRORS | null;
